import { render } from "./Textarea.vue?vue&type=template&id=87b29544&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=87b29544&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b29544"]])

export default __exports__